import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Frame from '../Onboarding/Frame';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';

import InvestorPersonality from './InvestorPersonality';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchContentPages } from '../../actions/contentPagesActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchOnboarding } from '../../actions/onboardingActions';

import { wlPath, wlVar } from '../../helpers/whitelabel';

// Calculators/index and Surveys/index use the same code.  Reflect changes in both files, or remove this notice.
export class Calculators extends Component {
  componentWillMount() {
    if (!this.props.dashboard.fetched || !this.props.dashboard.data.primary_person_id) {
      this.props.dispatch(fetchDashboard());
    }
    if (!this.props.people) {
      this.props.dispatch(fetchPeople());
    }
    if (!this.props.onboarding.fetched) this.props.dispatch(fetchOnboarding());
    if (!this.props.contentPages) {
      this.props.dispatch(fetchContentPages());
    }
  }

  render() {
    const { dashboard, history, match, user, contentPages, onboarding } = this.props;

    if (!user || !dashboard.fetched || !contentPages || !onboarding.fetched) {
      return <LoadingBar />;
    }

    if (!contentPages.length) {
      history.push(wlPath('/'));
    }

    if (!dashboard.data.primary_person_id) {
      return <LoadingBar />;
    }

    return (
      <Frame match={match}>
        <Switch>
          <Route exact path={match.url + '/investor-personality'} component={InvestorPersonality} />
        </Switch>
      </Frame>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    dashboard: state.modules.dashboard,
    people: state.modules.people,
    onboarding: state.onboarding,
    contentPages: state.contentPages.data,
  };
}

export default connect(mapStateToProps)(Calculators);
